export const gid_status_en = {
  "IDEA": "Idea",
  "IN_PROGRESS": "In Progress",
  "WAITING_FOR_DEVELOPMENT": "Waiting Development",
  "DEAD": "Dead",
  "DONE": "Done",
};
